import { Input, Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { BaseMemberSession } from 'src/app/models/member';

@Component({
    selector: 'mwp-multi-member-select',
    templateUrl: './multi-member-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiMemberSelectComponent implements OnInit {
    @Input() public baseMemberSessionList: BaseMemberSession[];
    @Input() public isLogin: boolean;
    @Input() public isRegister: boolean;
    @Output() public cancel: EventEmitter<any> = new EventEmitter;
    @Output() public submit: EventEmitter<BaseMemberSession> = new EventEmitter;


    public selectedMember: BaseMemberSession = null;
    public messageForDisplay: string = '';
    public baseMessage: string = 'This member belongs to the following Companies.';
    public resetPasswordMessage: string = 'Please choose one to email your account information:';
    public loginMessage: string = 'Please choose a member to login';
    public jsonKey: string;

    @HostListener('window:keydown.enter', ['$event']) onEnter(e: Event): void {
        if (e instanceof KeyboardEvent)
            e.preventDefault();

        if (this.selectedMember)
            this.submitEmit(this.selectedMember);

        e.preventDefault();
    }

    constructor() {
    }

    public ngOnInit(): void {
        if (this.isLogin || this.isRegister) {
            this.messageForDisplay = this.baseMessage + this.loginMessage;
            this.jsonKey = 'multiMemberBaseLogin';
        } else {
            this.messageForDisplay = this.baseMessage + this.resetPasswordMessage;
            this.jsonKey = 'multiMemberResetPassword';
        }
    }

    public cancelEmit(): void {
        this.cancel.emit();
    }

    public submitEmit(member: BaseMemberSession): void {
        this.submit.emit(member);
    }

}
